import { Zap, Shield, UserX, Gift } from 'lucide-react';

const features = [
  {
    icon: <Zap size={22} />,
    title: 'Fast',
    description: 'Lightweight tools that load quickly and work smoothly on desktop and mobile.',
  },
  {
    icon: <Shield size={22} />,
    title: 'Privacy Friendly',
    description: 'Many tools run in your browser so resumes, PDFs, and images stay on your device.',
  },
  {
    icon: <UserX size={22} />,
    title: 'No Sign-Up',
    description: 'Start using tools immediately — no account, email, or credit card required.',
  },
  {
    icon: <Gift size={22} />,
    title: 'Free To Use',
    description: 'Core utilities are free to use. Optional support helps fund new features.',
  },
];

export default function WhySection() {
  return (
    <section id="why" className="py-20 sm:py-28 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
            Why PixelUtility
          </h2>
          <p className="mt-3 text-gray-600 text-lg max-w-xl mx-auto">
            Built with care, designed for humans.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="text-center p-6 rounded-2xl hover:bg-gray-50 transition-colors"
            >
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-brand-100 to-blue-100 flex items-center justify-center text-brand-600 mx-auto mb-4">
                {feature.icon}
              </div>
              <h3 className="font-semibold text-gray-900">{feature.title}</h3>
              <p className="mt-2 text-sm text-gray-500 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
